var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-bottom":"8px"}},[_c('div',{staticClass:"bubble-text-label-wrap"},[_c('div',{staticClass:"bubble-text-label",style:({
      color: _vm.fontColor,
      backgroundColor: _vm.backgroundColor,
      border: ("2px solid " + _vm.fontColor),
    })},[_vm._v("\n    "+_vm._s(_vm.labelText)+"\n  ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }